module.exports = __webpack_public_path__ + "static/media/up-green.730271af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/up-green.svg
// module id = ./src/assets/icons/up-green.svg
// module chunks = 0